import { jsx as _jsx } from "react/jsx-runtime";
import { DataType, DataTypeOperator } from "../../models/audience/filter.model";
import { convertLocalDateToDate, formatDateDMYHM, formatDayMonth, formatFullDMY } from "../../utils/date.util";
import { Chip } from "@mui/material";
import { useIdTypeValues } from "./useIdTypeValues";
import { useLocalize } from "../../utils/text.util";
var FilterRuleSimplePreview = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var rule = _a.rule, index = _a.index, filterOptions = _a.filterOptions, filterRules = _a.filterRules, setFilterRules = _a.setFilterRules, handleExistingFilterClick = _a.handleExistingFilterClick;
    var _h = useLocalize(), t = _h.t, language = _h.language;
    var selectedOption = filterOptions.find(function (o) { return o.field === rule.field; });
    var fieldName = ((_b = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.localizations) === null || _b === void 0 ? void 0 : _b[language]) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) || rule.field;
    var idTypeValues = useIdTypeValues(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.idType, (((_c = rule.textValues) === null || _c === void 0 ? void 0 : _c.filter(Boolean)) || []));
    var operatorText = t("Data type operator ".concat(rule.operator));
    if ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.dataType) === DataType.LOCAL_DATE || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.dataType) === DataType.TIMESTAMP) {
        operatorText = t("Data type operator ".concat(rule.operator, " date"));
    }
    var dataTypeOperatorRequiredNumberOfValues = 0;
    switch (rule.operator) {
        case DataTypeOperator.EQUAL:
        case DataTypeOperator.NOT_EQUAL:
        case DataTypeOperator.MORE_THAN:
        case DataTypeOperator.MORE_THAN_EQUAL:
        case DataTypeOperator.LESS_THAN:
        case DataTypeOperator.LESS_THAN_EQUAL:
        case DataTypeOperator.LAST:
            dataTypeOperatorRequiredNumberOfValues = 1;
            break;
        case DataTypeOperator.BETWEEN:
        case DataTypeOperator.NOT_BETWEEN:
        case DataTypeOperator.PERIOD_BETWEEN:
        case DataTypeOperator.PERIOD_NOT_BETWEEN:
            dataTypeOperatorRequiredNumberOfValues = 2;
            break;
        case DataTypeOperator.CONTAINS:
        case DataTypeOperator.DOES_NOT_CONTAIN:
        case DataTypeOperator.SIMILAR_TO:
        case DataTypeOperator.STARTS_WITH:
        case DataTypeOperator.ENDS_WITH:
            dataTypeOperatorRequiredNumberOfValues = 1;
            break;
        case DataTypeOperator.IN:
        case DataTypeOperator.NOT_IN:
            dataTypeOperatorRequiredNumberOfValues = -1;
            break;
    }
    var renderValueOrQuestionMark = function (values, mapper) {
        if (dataTypeOperatorRequiredNumberOfValues === 0)
            return '';
        var cleanValues = ((values === null || values === void 0 ? void 0 : values.filter(Boolean)) || []).map(mapper);
        if (dataTypeOperatorRequiredNumberOfValues === -1) {
            return cleanValues.join(', ') || '?';
        }
        if (dataTypeOperatorRequiredNumberOfValues === 1) {
            return cleanValues[0] || '?';
        }
        if (dataTypeOperatorRequiredNumberOfValues === 2) {
            if (cleanValues.length === 0)
                return '? - ?';
            if (cleanValues.length === 1)
                return cleanValues[0] + ' - ?';
            return cleanValues.join(' - ');
        }
        return cleanValues.join(', ') || '?';
    };
    var valueText = '';
    if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.idType) {
        valueText = idTypeValues.map(function (v) { return v.name; }).join(', ');
    }
    else {
        switch (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.dataType) {
            case DataType.NUMBER:
                valueText = renderValueOrQuestionMark(rule.longValues || [], function (v) { return v.toString(); });
                break;
            case DataType.DECIMAL:
                valueText = renderValueOrQuestionMark(rule.doubleValues || [], function (v) { return v.toString(); });
                break;
            case DataType.TEXT:
                valueText = renderValueOrQuestionMark(rule.textValues || [], function (v) { return v.toString(); });
                break;
            case DataType.BOOL:
                break;
            case DataType.ENUM:
                valueText = t(renderValueOrQuestionMark(rule.textValues || [], function (v) { return v.toString(); }));
                break;
            case DataType.LOCAL_DATE:
                if (rule.operator === DataTypeOperator.LAST) {
                    valueText = ((_e = (_d = rule.longValues) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.toString()) || '?';
                }
                else if (rule.operator === DataTypeOperator.PERIOD_BETWEEN || rule.operator === DataTypeOperator.PERIOD_NOT_BETWEEN) {
                    valueText = renderValueOrQuestionMark(rule.localDateValues || [], function (v) { return formatDayMonth(convertLocalDateToDate(v)); });
                }
                else {
                    valueText = renderValueOrQuestionMark(rule.localDateValues || [], function (v) { return formatFullDMY(convertLocalDateToDate(v)); });
                }
                break;
            case DataType.TIMESTAMP:
                if (rule.operator === DataTypeOperator.LAST) {
                    valueText = ((_g = (_f = rule.longValues) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.toString()) || '?';
                }
                else if (rule.operator === DataTypeOperator.PERIOD_BETWEEN || rule.operator === DataTypeOperator.PERIOD_NOT_BETWEEN) {
                    valueText = renderValueOrQuestionMark(rule.timestampValues || [], function (v) { return formatDayMonth(new Date(v)); });
                }
                else {
                    valueText = renderValueOrQuestionMark(rule.timestampValues || [], function (v) { return formatDateDMYHM(new Date(v)); });
                }
                break;
        }
    }
    var combined = [fieldName, operatorText, valueText].filter(Boolean).join(' ');
    return (_jsx(Chip, { label: combined, onDelete: function () {
            setFilterRules(filterRules.filter(function (r, i) { return i !== index; }));
        }, onClick: function (event) { return handleExistingFilterClick(event, index); }, color: 'info' }));
};
export default FilterRuleSimplePreview;
